import { IOffer } from '../types';
import { getCurrency } from '../utils/dazn/Region';
import localisePrice from '../utils/localisePrice';

export const getSavePrice = (offers: IOffer[], entitlementSetId: string) => {
    try {
        let hasInstalmentDiscount: boolean = false;
        let hasAnnualDiscount: boolean = false;
        let installmentPrice: number | null | undefined = null;
        let discountedInstallmentPrice: number | null | undefined = null;
        let instalmentFrequency: number | undefined = 0;
        let discountedInstalmentFrequency: number | undefined = 0;
        let annualPrice: number | null | undefined = null;
        let discountedAnnualPrice: number = 0;
        let monthlyPrice: number | null | undefined = null;
        offers
            .filter((offer: IOffer) => offer.EntitlementSetId === entitlementSetId)
            .forEach((offer: IOffer) => {
                const chargeTier = offer.ChargeTiers?.find(
                    (offer) =>
                        offer.Currency?.toLocaleLowerCase() ===
                        getCurrency()?.toLocaleLowerCase()
                );
                if (offer?.BillingPeriod === 'Instalments') {
                    installmentPrice = chargeTier?.Price;
                    instalmentFrequency = offer.Instalment?.TermInMonths;
                    if (chargeTier?.Discount) {
                        hasInstalmentDiscount = true;
                        discountedInstallmentPrice = chargeTier?.Discount?.Price;
                        discountedInstalmentFrequency =
                            chargeTier?.Discount?.DiscountedMonths;
                    }
                } else if (offer?.BillingPeriod === 'Annual') {
                    annualPrice = chargeTier?.Price;
                    if (chargeTier?.Discount) {
                        hasAnnualDiscount = true;
                        discountedAnnualPrice = chargeTier?.Discount?.Price ?? 0;
                    }
                } else if (offer?.BillingPeriod === 'Month') {
                    monthlyPrice = chargeTier?.Price;
                }
            });

        if (
            installmentPrice === null ||
            annualPrice === null ||
            monthlyPrice === null ||
            (discountedInstallmentPrice === null && hasInstalmentDiscount)
        ) {
            return null;
        }

        const discountedInstallmentCost =
            (discountedInstallmentPrice ?? 0) * discountedInstalmentFrequency;

        const afterDiscountedRemainInstallCost =
            installmentPrice *
            (instalmentFrequency - discountedInstalmentFrequency);

        const totalDiscountedInstallmentCost =
            discountedInstallmentCost + afterDiscountedRemainInstallCost;

        const totalInstallmentCost = hasInstalmentDiscount
            ? totalDiscountedInstallmentCost
            : installmentPrice * instalmentFrequency;

        const totalAnnualCost = hasAnnualDiscount
            ? discountedAnnualPrice
            : annualPrice;

        const savingsPercentage =
            ((totalInstallmentCost -
                (hasAnnualDiscount ? discountedAnnualPrice : annualPrice)) /
                (hasAnnualDiscount ? discountedAnnualPrice : annualPrice)) *
            100;

        const savingPrice =
            totalInstallmentCost -
            (hasAnnualDiscount ? discountedAnnualPrice : annualPrice);

        const savingDiscountedAnnualPrice =
            annualPrice - (hasAnnualDiscount ? discountedAnnualPrice : annualPrice);

        return {
            savingsPercentage: localisePrice(
                Math.floor(savingsPercentage * 100) / 100
            ),
            totalSavingPrice: localisePrice(Math.floor(savingPrice * 100) / 100),
            annualSavingsWithInstallment: localisePrice(
                Math.floor(monthlyPrice * 12 - totalInstallmentCost)
            ),
            annualSavingsWithMonth: localisePrice(
                Math.floor(monthlyPrice * 12 - totalAnnualCost)
            ),
            savingDiscountedAnnualPrice: localisePrice(
                Math.floor(savingDiscountedAnnualPrice * 100) / 100
            )
        };
    } catch (e) {
        return {};
    }
};
